import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";

export interface GetCoveoProductsRecommendationApiParameter extends ApiParameter, HasPagingParameters {
    query?: string;
    numberOfResults?: number;
    actionsHistory?: any;
    additionalExpands?: any;
}

const productRecommendationsUrl = "/api/v2/products";

export function getCoveoProductsRecommendation(parameter: GetCoveoProductsRecommendationApiParameter) {
    const queryParams = {
        query: parameter.query,
        pageSize: parameter.numberOfResults,
        actionsHistory: JSON.stringify([{
            name: parameter.actionsHistory?.name,
            time: parameter.actionsHistory?.time,
            value: window?.location.href,
        }]),
        searchHub: 'recs',
        expand: parameter.additionalExpands,
        documentLocation: parameter.actionsHistory?.documentLocation,
        documentReferrer: parameter.actionsHistory?.documentReferrer,
        isCoveoRecommendedProducts: true,
    } as any;
    const queryString = new URLSearchParams(queryParams).toString();


    return get<any>(`${productRecommendationsUrl}?${queryString}`);
}
